<template>
  <div style="height:100%;position: relative;">
    <div  class="no-found-data-warpper">
      <img src="../../assets/img/loading.png" class="loading"/>
    </div>
    <div class="component">
      <component :is="componentName"/>
    </div>
  </div>
</template>
<script>
import Overview from "./sheet/Overview";
import Comparison from "./sheet/Comparison";
import Savingplan from "./sheet/Savingplan";
import Structure from "./sheet/Structure";
import EnergyReport from "./sheet/EnergyReport";
import PinnacleData from "./sheet/PinnacleData";
export default {
  name: "EnergyEfficiency",
  components: {
    Overview,
    Comparison,
    Savingplan,
    Structure,
    EnergyReport,
    PinnacleData
  },
  data() {
    return {
      
    };
  },

  computed: {
    componentName() {
      switch (this.$route.params.name) {
        case "Overview": return 'Overview';
        case "Comparison": return 'Comparison';
        case "Structure": return 'Structure';
        case "EnergyReport": return 'EnergyReport';
      }
    },
    tag() {
      return this.$route.params.tag;
    },
    routeName() {
      return this.$route.params.name;
    },
  },
  mounted() {
      
      
  },
  methods: {
    
  },
  watch: {
  }
};
</script>

<style scoped lang="less">
  .no-found-data-warpper{
    height: 100%;
    background: #fff;
    text-align: center;

  }
  .component{
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
  
	.loading {
		width: 28rem;
		height: 28rem;
    position: absolute;
    top: 45%;
		animation: loading 1s linear infinite;
	}
  
	@keyframes loading {
		0% {
			transform: rotate(0);
		}
		100% {
			transform: rotate(360deg);
		}
	}
</style>
